import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.resultContainer = document.getElementById('translationResult')
  }

  view(event) {
    const button = event.currentTarget
    const documentId = button.dataset.documentId
    
    if (documentId) {
      // Update chat sidebar and trigger change event
      const chatController = document.querySelector('[data-controller="chat"]');
      if (chatController) {
        const select = chatController.querySelector('[data-chat-target="documentSelect"]');
        if (select) {
          select.value = documentId;
          
          // Update the chat controller's documentIdValue
          const chatStimulusController = this.application.getControllerForElementAndIdentifier(
            chatController, 'chat'
          );
          if (chatStimulusController) {
            chatStimulusController.documentIdValue = documentId;
          }
          
          // Trigger the change event to load messages
          select.dispatchEvent(new Event('change'));
        }
      }

      // Fetch and display translation directly
      fetch(`/pdf_translator/get_translation/${documentId}`, {
        headers: {
          'Accept': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        }
      })
      .then(response => response.json())
      .then(data => {
        const resultContainer = document.getElementById('translationResult');
        const originalText = document.getElementById('originalText');
        const translatedText = document.getElementById('translatedText');
        
        if (resultContainer && originalText && translatedText) {
          resultContainer.classList.remove('d-none');
          originalText.innerHTML = this.formatParagraphs(data.original_text || '');
          translatedText.innerHTML = this.formatParagraphs(data.translated_text || '');
          resultContainer.scrollIntoView({ behavior: 'smooth' });
        }
      })
      .catch(error => console.error('Error:', error));
    }
  }

  formatParagraphs(text) {
    return text.split(/\n\s*\n/).map((para, i) => 
      `<div class="paragraph" data-para-id="${i}">${para.trim().replace(/\n/g, '<br>')}</div>`
    ).join('\n\n')
  }
}
